import { css } from "@emotion/css";
import { jsx as _jsx } from "react/jsx-runtime";
const imageWrapper = css({ backgroundSize: "contain", backgroundPosition: "center center", backgroundRepeat: "no-repeat", flex: 1, padding: 10 });
const image = css({ maxWidth: "100%", maxHeight: "100%" });
export function FullSizeImage(props) {
    if (!props.src.startsWith("data:")) { // use <img so that chrome will wait for the load complete before printing
        // and referenced files are "hopefully" have more predicable sizes
        return /*#__PURE__*/ _jsx("div", { className: imageWrapper, children: /*#__PURE__*/ _jsx("img", { src: fixPdfPath(props.src), className: image, alt: "full page screenshot" }) });
    } // use background image for data-urls b/c they have all different dimensions (from canvas screenshots)
    return /*#__PURE__*/ _jsx("div", { className: imageWrapper, style: { backgroundImage: "url('" + fixPdfPath(props.src) + "')" } });
}
export function fixPdfPath(input) { if (input.startsWith("/")) {
    let route = window.location.protocol + "//" + window.location.host + input;
    console.log("route-fixed", route);
    return route;
} return input; }
